import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'learning.survey.title',
    defaultMessage: 'Survey',
    description: 'The title of the course survey page.',
  },
  loading: {
    id: 'learning.survey.loading',
    defaultMessage: 'Loading surveys...',
    description: 'Screen reader text while surveys are loading.',
  },
  loadingSurvey: {
    id: 'learning.survey.loadingSurvey',
    defaultMessage: 'Loading survey...',
    description: 'Screen reader text while a survey form is loading.',
  },
  loadingAnswers: {
    id: 'learning.survey.loadingAnswers',
    defaultMessage: 'Loading answers...',
    description: 'Screen reader text while survey answers are loading.',
  },
  noSurveys: {
    id: 'learning.survey.noSurveys',
    defaultMessage: 'No survey is available for this course.',
    description: 'Message shown when the course has no available surveys.',
  },
  notAnswered: {
    id: 'learning.survey.notAnswered',
    defaultMessage: 'Not answered',
    description: 'Status label for an unanswered survey.',
  },
  completed: {
    id: 'learning.survey.completed',
    defaultMessage: 'Completed',
    description: 'Status label for an answered survey.',
  },
  questions: {
    id: 'learning.survey.questions',
    defaultMessage: '{count, plural, one {# question} other {# questions}}',
    description: 'Question count text for a survey.',
  },
  answerSurvey: {
    id: 'learning.survey.answerSurvey',
    defaultMessage: 'Answer survey',
    description: 'Button label to open a survey form.',
  },
  viewAnswers: {
    id: 'learning.survey.viewAnswers',
    defaultMessage: 'View answers',
    description: 'Button label to view submitted survey answers.',
  },
  submit: {
    id: 'learning.survey.submit',
    defaultMessage: 'Submit',
    description: 'Button label to submit a survey.',
  },
  submitting: {
    id: 'learning.survey.submitting',
    defaultMessage: 'Submitting...',
    description: 'Button label while a survey is being submitted.',
  },
  cancel: {
    id: 'learning.survey.cancel',
    defaultMessage: 'Cancel',
    description: 'Button label to cancel survey answering.',
  },
  goBack: {
    id: 'learning.survey.goBack',
    defaultMessage: 'Go back',
    description: 'Button label to return to the survey list.',
  },
  chooseOption: {
    id: 'learning.survey.chooseOption',
    defaultMessage: 'Choose an option',
    description: 'Placeholder option for select survey questions.',
  },
  requiredQuestion: {
    id: 'learning.survey.requiredQuestion',
    defaultMessage: 'This question is required.',
    description: 'Validation message shown for required survey questions.',
  },
  submitError: {
    id: 'learning.survey.submitError',
    defaultMessage: 'We could not submit your survey. Please try again.',
    description: 'Error message shown when survey submission fails.',
  },
  loadError: {
    id: 'learning.survey.loadError',
    defaultMessage: 'We could not load surveys. Please try again later.',
    description: 'Error message shown when surveys fail to load.',
  },
  answerSubmitted: {
    id: 'learning.survey.answerSubmitted',
    defaultMessage: 'Thank you. Your answers were submitted.',
    description: 'Success message shown after survey submission.',
  },
  noAnswerProvided: {
    id: 'learning.survey.noAnswerProvided',
    defaultMessage: 'No answer provided',
    description: 'Fallback text when a submitted survey answer is empty.',
  },
  noAnswersFound: {
    id: 'learning.survey.noAnswersFound',
    defaultMessage: 'No submitted answers were found for this survey.',
    description: 'Message shown when no answers are available for a completed survey.',
  },
  invalidDefinition: {
    id: 'learning.survey.invalidDefinition',
    defaultMessage: 'This survey cannot be displayed because its definition is invalid.',
    description: 'Message shown when survey definition cannot be parsed.',
  },
});

export default messages;
